"use strict";var r=require("./hasData-cjs-BbcTd98W.js");exports.i=s=>{const{product:t,params:a}=s;return(null===t||r.h(a))&&s||{}};